import { render } from "./CitiesList.vue?vue&type=template&id=635732ee&scoped=true&ts=true"
import script from "./CitiesList.vue?vue&type=script&lang=ts"
export * from "./CitiesList.vue?vue&type=script&lang=ts"

import "./CitiesList.vue?vue&type=style&index=0&id=635732ee&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635732ee"]])

export default __exports__